import React, { memo, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import {
  InputBase,
  Paper,
  ClickAwayListener,
  Typography,
  CircularProgress,
} from '@material-ui/core';

// import SelectComp from '../../SelectComp';
import Style from './Style';
import { searchCustomer } from '../../../actions/customer/customer-actions';

const useStyles = makeStyles((theme) => Style(theme));

const VehicleListSearch = ({ setSelectedCustomer }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [searchValue, setSearchValue] = useState('');
  const [showCustomers, setShowCustomers] = useState(false);

  const searchedCustomers = useSelector(
    (state) => state.customer?.searchedCustomers || [],
  );

  const searchCustomerLoading = useSelector(
    (state) => state.customer?.searchCustomerLoading || false,
  );

  const handleChangeSearch = _.debounce(async (value) => {
    if (!showCustomers) {
      setShowCustomers(true);
    }
    if (value) {
      dispatch(searchCustomer({ searchValue: value }));
    } else {
      setShowCustomers(false);

      dispatch({ type: 'CLEAR_SEARCH_CUSTOMER_STATE' });
    }
  }, 500);

  const handleSearchCustomers = useCallback(
    (value) => {
      setSearchValue(value);
      handleChangeSearch(value);
    },
    [searchValue],
  );

  const handleSelectCustomer = (customer) => {
    setSelectedCustomer(customer);
    setShowCustomers(false);
    setSearchValue('');
    dispatch({ type: 'CLEAR_SEARCH_CUSTOMER_STATE' });
  };

  return (
    <>
      <Paper className={clsx(classes.root)}>
        <InputBase
          inputProps={{ 'aria-label': 'search customer' }}
          className={classes.input}
          onChange={(e) => {
            handleSearchCustomers(e.target.value?.trimStart());
          }}
          onFocus={() => {
            if (searchValue && !showCustomers) {
              setShowCustomers(true);
            }
          }}
          value={searchValue || ''}
          autoFocus
          placeholder='Search Customer via Name, Phone or Email, USDOT Number, PST Number'
          autoComplete='off'
        />

        {showCustomers ? (
          searchCustomerLoading ? (
            <div
              className={classes.root__dropdown__main}
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <CircularProgress size={20} />
            </div>
          ) : (
            <ClickAwayListener
              onClickAway={() => {
                setShowCustomers(false);
              }}
            >
              {searchedCustomers?.length ? (
                <div className={classes.root__dropdown__main}>
                  {searchedCustomers?.map((customer, key) => {
                    return (
                      <div
                        className={clsx(
                          'd-flex flex-col',
                          'c-pointer',
                          classes.customer__search__list__item,
                        )}
                        onClick={() => handleSelectCustomer(customer)}
                      >
                        <Typography
                          className={clsx(
                            classes.customer__search__menu__text__heading,
                          )}
                          key={key++}
                        >
                          {customer?.name || '-'}
                        </Typography>
                        <div className='d-flex flex-col space-between'>
                          <Typography
                            className={clsx(
                              classes.customer__search__menu__text,
                            )}
                            key={key++}
                          >
                            Phone :{' '}
                            <span style={{ fontWeight: 400 }}>
                              {customer.phone || '-'}
                            </span>
                          </Typography>
                          <Typography
                            className={clsx(
                              classes.customer__search__menu__text,
                            )}
                            key={key++}
                          >
                            Email:{' '}
                            <span style={{ fontWeight: 400 }}>
                              {customer?.email || '-'}
                            </span>
                          </Typography>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div
                  className={classes.root__dropdown__main}
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Typography
                    className={clsx(classes.dropdown__menu__text)}
                    style={{
                      color: '#000000',
                      fontWeight: 400,
                      fontSize: '12px',
                      lineHeight: '19px',
                    }}
                  >
                    Result Not Found!
                  </Typography>
                </div>
              )}
            </ClickAwayListener>
          )
        ) : (
          ''
        )}
      </Paper>
    </>
  );
};

export default memo(VehicleListSearch);
